import Vue from "vue";
import VueI18n from "vue-i18n";
import axios from "axios";
import messengerMessages from "./locales/messenger";
import broadcastMessages from "./locales/broadcast";
import broadcastScreenMessages from "./locales/broadcastScreens";
Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  silentTranslationWarn: true,
});

// Messenger strings (locales/messenger.js) on top of whatever is loaded. setLocaleMessage replaces
// a whole locale, so this runs after it. It never throws: the app shows its loading spinner until
// the locale switches, so an error here must not stop that switch.
function mergeMessengerMessages() {
  ["th", "en"].forEach((lang) => {
    try {
      if (messengerMessages[lang]) i18n.mergeLocaleMessage(lang, messengerMessages[lang]);
      if (broadcastMessages[lang]) i18n.mergeLocaleMessage(lang, broadcastMessages[lang]);
      if (broadcastScreenMessages[lang]) i18n.mergeLocaleMessage(lang, broadcastScreenMessages[lang]);
    } catch (e) {
      console.error("[i18n] Messenger messages not merged for " + lang, e);
    }
  });
}

function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}

export function loadLanguageAsync(lang) {
  axios({
    url: 'https://proship-dev.s3-ap-southeast-1.amazonaws.com/proship_files/translations.json',
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const blob = new Blob([response.data], { type: 'application/json' });
    var reader = new FileReader();
    reader.onload = () => {
      let json = JSON.parse(reader.result);
      i18n.setLocaleMessage(lang, json);
      mergeMessengerMessages();
      setI18nLanguage(lang);
    }
    reader.readAsText(blob);
  }).catch((e) => {
    // S3 file not loaded: the app stays on its spinner as before; the Messenger strings are merged anyway
    console.error("[i18n] translations not loaded", e);
    mergeMessengerMessages();
  });
}
